/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [
  {
    id: 1,
    mealType: "breakfast",
    recipeName: "PEACHES AND CREAM OVERNIGHT OATS",
    recipePublisher: "eatgood4life",
    recipeURL: "https://www.eatgood4life.com/peaches-and-cream-overnight-oats/",
    imgURL:
      "https://www.eatgood4life.com/wp-content/uploads/2015/06/peach-and-cream-overnight-oats-200x263.jpg",
    description:
      "Here you have it, the peaches and cream overnight oats recipe I promised a few days back. Another sensational flavor of overnight oats that is gluten-free, vegan and perfect since peaches are in season.",
    servings: 10,
    totalTime: 10,
    diets: [],
    intolerances: [],
    ingredients: [
      {
        id: 10,
        originalName: "4 cups gluten-free rolled oats",
        amount: {
          metric: {
            amount: 360,
            unit: "gram(s)",
          },
          us: {
            amount: 4,
            unit: "cup(s)",
          },
        },
      },
      {
        id: 11,
        originalName: "4 large peaches, cut into chunks",
        amount: {
          metric: {
            amount: 700,
            unit: "gram(s)",
          },
          us: {
            amount: 4,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 12,
        originalName: "6 cups unsweetened cashew milk",
        amount: {
          metric: {
            amount: 1440,
            unit: "mililiters(s)",
          },
          us: {
            amount: 6,
            unit: "cup(s)",
          },
        },
      },
      {
        id: 13,
        originalName: "1 cup coconut cream",
        amount: {
          metric: {
            amount: 296,
            unit: "gram(s)",
          },
          us: {
            amount: 1,
            unit: "cup(s)",
          },
        },
      },
      {
        id: 14,
        originalName: "3 tsp cinnamon powder",
        amount: {
          metric: {
            amount: 8.28,
            unit: "gram(s)",
          },
          us: {
            amount: 3,
            unit: "tsp",
          },
        },
      },
      {
        id: 15,
        originalName: "1/3 cup chia seeds",
        amount: {
          metric: {
            amount: 54,
            unit: "gram(s)",
          },
          us: {
            amount: 0.33,
            unit: "cup(s)",
          },
        },
      },
      {
        id: 16,
        originalName: "1/3 cup maple syrup",
        amount: {
          metric: {
            amount: 110,
            unit: "gram(s)",
          },
          us: {
            amount: 0.33,
            unit: "cup(s)",
          },
        },
      },
      {
        id: 17,
        originalName: "1/2 cup pecans, chopped",
        amount: {
          metric: {
            amount: 75,
            unit: "gram(s)",
          },
          us: {
            amount: 0.5,
            unit: "cup(s)",
          },
        },
      },
    ],
    directions: [
      {
        step: 1,
        description:
          "In a large mixing bowl add all the ingredients and with a large spoon mix until combined.",
      },
      {
        step: 2,
        description:
          "Place mixture covered in the refrigerator overnight. Serve with extra milk, warm, cold or as desired!",
      },
    ],
    isFavorite: false,
  },
  {
    id: 2,
    mealType: "lunch",
    recipeName: "ROASTED TOMATO, EGGPLANT AND HALOUMI BURGER",
    recipePublisher: "Donna Hay",
    recipeURL:
      "https://www.donnahay.com.au/recipes/mains/vegetables/roasted-tomato-eggplant-and-haloumi-burger",
    imgURL:
      "https://cdn.donnahaycdn.com.au/images/content-images/roasted-tomato-eggplant-and-haloumi-burger.jpg",
    description: "ROASTED TOMATO, EGGPLANT AND HALOUMI BURGER",
    servings: 4,
    totalTime: 30,
    diets: [],
    intolerances: [],
    ingredients: [
      {
        id: 19,
        originalName: "2 VINE-RIPENED TOMATOES, THICKLY SLICED",
        amount: {
          metric: {
            amount: 246,
            unit: "gram(s)",
          },
          us: {
            amount: 2,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 5,
        originalName: "OLIVE OIL, FOR BRUSHING ",
        amount: {
          metric: {
            amount: 10,
            unit: "mililiters(s)",
          },
          us: {
            amount: 2,
            unit: "tsp(s)",
          },
        },
      },
      {
        id: 25,
        originalName: "4 BURGER BUNS, HALVED",
        amount: {
          metric: {
            amount: 212,
            unit: "gram(s)",
          },
          us: {
            amount: 4,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 26,
        originalName: "1 EGGPLANT (AUBERGINE), THINLY SLICED ",
        amount: {
          metric: {
            amount: 550,
            unit: "gram(s)",
          },
          us: {
            amount: 1,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 27,
        originalName: "250G HALOUMI, SLICED",
        amount: {
          metric: {
            amount: 250,
            unit: "gram(s)",
          },
          us: {
            amount: 250,
            unit: "gram(s)",
          },
        },
      },
      {
        id: 28,
        originalName: "HARISSA MAYONNAISE ",
        amount: {
          metric: {
            amount: 19,
            unit: "grams(s)",
          },
          us: {
            amount: 4,
            unit: "tsp(s)",
          },
        },
      },
      {
        id: 29,
        originalName: "CARAMELISED RED ONIONS, TO SERVE",
        amount: {
          metric: {
            amount: 19,
            unit: "grams(s)",
          },
          us: {
            amount: 4,
            unit: "tsp(s)",
          },
        },
      },
      {
        id: 30,
        originalName: "ROCKET (ARUGULA) LEAVES, TO SERVE",
        amount: {
          metric: {
            amount: 20,
            unit: "grams(s)",
          },
          us: {
            amount: 20,
            unit: "grams(s)",
          },
        },
      },
    ],
    directions: [
      {
        step: 1,
        description:
          "Preheat oven to 180°C (355°F). Place the tomato on a baking tray and brush with oil. Roast for 20 minutes or until cooked. Set aside. ",
      },
      {
        step: 2,
        description:
          "Brush the bun halves with oil and place on a baking tray. Grill (broil) under a preheated hot grill for 1 minute or until golden. Set aside. Heat a char-grill pan or barbecue over high heat. Brush the eggplant with oil and char-grill or barbecue for 2 minutes each side or until cooked through. Set aside. ",
      },
      {
        step: 3,
        description:
          "Brush the haloumi with oil and char-grill or barbecue for 1 minute each side or until golden. Spread the bun halves with harissa mayonnaise and top with the tomato, eggplant, haloumi, caramelised onions and rocket leaves to serve.",
      },
    ],
    isFavorite: false,
  },
  {
    id: 3,
    mealType: "dinner",
    recipeName: "Greek Salad (Horiatiki)",
    recipePublisher: "Saveur",
    recipeURL: "https://www.saveur.com/article/Recipes/Greek-Salad-Horiatiki/",
    imgURL:
      "https://www.saveur.com/app/uploads/2019/01/22/PFWVJL672VPBJNPJ4G7CYAT5MA.jpg?width=785",
    description:
      "This refreshing salad takes on various guises in Greece depending on what vegetables are in season, but it almost always features feta and a dusting of dried oregano.",
    servings: 2,
    totalTime: 20,
    diets: [],
    intolerances: [],
    ingredients: [
      {
        id: 18,
        originalName:
          "2 tbsp. roughly chopped fresh parsley, plus more for garnish",
        amount: {
          metric: {
            amount: 7.6,
            unit: "gram(s)",
          },
          us: {
            amount: 2,
            unit: "tbsp(s)",
          },
        },
      },
      {
        id: 19,
        originalName: '2 medium vine-ripened tomatoes, cut into 1 1/2" pieces',
        amount: {
          metric: {
            amount: 246,
            unit: "gram(s)",
          },
          us: {
            amount: 2,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 20,
        originalName:
          '1 small cucumber, peeled, halved lengthwise, and sliced crosswise into 1/4" pieces',
        amount: {
          metric: {
            amount: 158,
            unit: "gram(s)",
          },
          us: {
            amount: 1,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 4,
        originalName: "1⁄2 medium white onion, thinly sliced",
        amount: {
          metric: {
            amount: 35,
            unit: "gram(s)",
          },
          us: {
            amount: 0.5,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 5,
        originalName: "3 tbsp. extra-virgin olive oil",
        amount: {
          metric: {
            amount: 45,
            unit: "mililiters(s)",
          },
          us: {
            amount: 3,
            unit: "tbsp(s)",
          },
        },
      },
      {
        id: 21,
        originalName: "1 tbsp. red wine vinegar",
        amount: {
          metric: {
            amount: 14.4,
            unit: "mililiters(s)",
          },
          us: {
            amount: 1,
            unit: "tbsp(s)",
          },
        },
      },
      {
        id: 22,
        originalName: "1⁄8 tsp. dried oregano, plus more",
        amount: {
          metric: {
            amount: 0.125,
            unit: "gram(s)",
          },
          us: {
            amount: 0.125,
            unit: "tsp(s)",
          },
        },
      },
      {
        id: 6,
        originalName: "Kosher salt, to taste",
        amount: {
          metric: {
            amount: 3,
            unit: "gram(s)",
          },
          us: {
            amount: 0.5,
            unit: "tsp(s)",
          },
        },
      },
      {
        id: 7,
        originalName: "Freshly ground black pepper, to taste",
        amount: {
          metric: {
            amount: 1.2,
            unit: "gram(s)",
          },
          us: {
            amount: 0.5,
            unit: "tsp(s)",
          },
        },
      },
      {
        id: 23,
        originalName: "6 oz. feta, cut into thick slabs",
        amount: {
          metric: {
            amount: 170,
            unit: "gram(s)",
          },
          us: {
            amount: 6,
            unit: "oz",
          },
        },
      },
      {
        id: 24,
        originalName: "8 kalamata olives",
        amount: {
          metric: {
            amount: 32,
            unit: "gram(s)",
          },
          us: {
            amount: 8,
            unit: "piece(s)",
          },
        },
      },
    ],
    directions: [
      {
        step: 1,
        description:
          "Combine parsley, tomatoes, cucumbers, and onions in a bowl. In a small bowl, whisk together oil, vinegar, and oregano; season with salt and pepper and pour over cucumber mixture. Toss. Transfer salad to a serving bowl and top with feta and olives. Garnish with more oregano; season with pepper.",
      },
    ],
    isFavorite: false,
  },
  {
    id: 4,
    mealType: "snack",
    recipeName: "Mediterranean Picnic Snack",
    recipePublisher: "EatingWell",
    recipeURL:
      "http://www.eatingwell.com/recipe/249036/mediterranean-picnic-snack/",
    imgURL:
      "https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F44%2F2019%2F08%2F26231107%2F3746623.jpg",
    description:
      "Sweet tomatoes, salty olives and tangy cheese are a perfect afternoon pick-me-up.",
    servings: 1,
    totalTime: 5,
    diets: [],
    intolerances: [],
    ingredients: [
      {
        id: 32,
        originalName:
          "1 slice crusty whole-wheat bread, cut into bite-size pieces",
        amount: {
          metric: {
            amount: 32,
            unit: "gram(s)",
          },
          us: {
            amount: 1,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 31,
        originalName: "10 cherry tomatoes",
        amount: {
          metric: {
            amount: 170,
            unit: "gram(s)",
          },
          us: {
            amount: 10,
            unit: "piece(s)",
          },
        },
      },
      {
        id: 33,
        originalName: "¼ ounce sliced aged cheese",
        amount: {
          metric: {
            amount: 7,
            unit: "gram(s)",
          },
          us: {
            amount: 0.25,
            unit: "oz",
          },
        },
      },
      {
        id: 36,
        originalName: "6 oil-cured olives",
        amount: {
          metric: {
            amount: 18,
            unit: "gram(s)",
          },
          us: {
            amount: 6,
            unit: "piece(s)",
          },
        },
      },
    ],
    directions: [
      {
        step: 1,
        description:
          "Combine bread pieces, tomatoes, cheese and olives in a portable container.",
      },
    ],
    isFavorite: false,
  },
];
